import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Play, Pause } from "lucide-react";
import { content } from "../../data/content";
import { initMusic, toggleMusic, subscribe, getState } from "../../lib/music";

export function MusicPlayer() {
  const [st, setSt] = useState(getState());

  useEffect(() => {
    initMusic(content.music.src);
    const unsub = subscribe(setSt);
    return unsub;
  }, []);

  return (
    <motion.button
      data-testid="music-toggle"
      data-playing={st.playing ? "true" : "false"}
      onClick={toggleMusic}
      aria-label={st.playing ? "Pausar música" : "Reproducir música"}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.4, duration: 0.5, ease: [0.34, 1.56, 0.64, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.9 }}
      className="fixed z-[9998] bottom-5 right-5 md:bottom-7 md:right-7 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-ink text-white border-[3px] border-ink shadow-brutal"
    >
      {/* pulsing ring when playing */}
      {st.playing && (
        <motion.span
          className="absolute inset-0 rounded-full border-[3px] border-rose"
          animate={{ scale: [1, 1.35], opacity: [0.7, 0] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: "easeOut" }}
        />
      )}
      <span className="relative flex items-center justify-center w-9 h-9 md:w-10 md:h-10 rounded-full bg-rose">
        {st.playing ? (
          <Pause className="w-5 h-5 fill-white" />
        ) : (
          <Play className="w-5 h-5 fill-white translate-x-[1px]" />
        )}
      </span>
    </motion.button>
  );
}
